// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"12c1b776","81":"9e2349f1"}[chunkId] + ".chunk.js";
};